import React, { useState } from 'react'
import SkillsCards from './SkillsCards'
import { FaArrowCircleDown, FaArrowCircleUp } from 'react-icons/fa'
import '../css/Skills.css'

const Skills = () => {
    const mySkills = [
        { 
            "id": 1,
            "name": "C",
            "description": "First language that I learned while getting into programming. Mainly uee it write algorithms.",
        },
        { 
            "id": 2,
            "name": "Java",
            "description": "Learned Java following OOP manner. Use it to practice my oop skills." ,
        },
        { 
            "id": 3,
            "name": "JavaScript",
            "description": "One of my favourite languages. As it can be used to create web apps and also mobile apps." ,
        },
        { 
            "id": 4,
            "name": "PHP",
            "description": "The first programming language I learned that could be used to create web applications. Loved to use it as tha back-end." 
        },
        { 
            "id": 5,
            "name": "Python",
            "description": "Antoher favourite language of mine as it is easy to understand at same time so much powerful. Usually use it as the backend of my web appliccations." 
        },
        { 
            "id": 6,
            "name": "TypeScript",
            "description": "Some times use it instead of javascript as it solves my problems that occur while developing apps using Javascript. " 
        },
        { 
            "id": 7,
            "name": "React.Js",
            "description": "Currently working on it and creating apps using React.js for it gives the flexibility to develop powerful and moden websiltes easily." 
        },
        { 
            "id": 8,
            "name": "Flask",
            "description": "My favourite back-end framework. I love it because it is easy to work with and it helped me to understand other frameworks." 
        },
        { 
            "id": 9,
            "name": "MySql",
            "description": "Used it in some of my projects to store data." 
        },
        { 
            "id": 10,
            "name": "MongoDB",
            "description": "Currently use it instead of other sql languages because it is easy to use and modify." 
        },
    ]

    const [skillCount, setSkillCount] = useState(mySkills.slice(0,3))
    const [isLoading, setIsLoading] = useState(false)
    const [isShowingAll, setIsShowingAll] = useState(false)


    const showAll = () => {
        setIsLoading(true)
        const post = mySkills.slice(0, mySkills.length)
        setIsShowingAll(true)
        setSkillCount(post)
        setIsLoading(false)
    }

    const showLess = () => {
        setIsLoading(true)
        const post = mySkills.slice(0, 3)
        setSkillCount(post)
        setIsShowingAll(false)
        setIsLoading(false)
    }

    return (
        <div className="skillsContainer" id="skills">
           <div className="skillsHeader">
               <div className="skillsHeaderText">Skills</div>
           </div>
           <div>
                {
                    isLoading === false ? 
                    <div className="skillsAllCardContainer">
                        <SkillsCards mySkills={skillCount} isProjects={false} />
                    </div> : <div className="alert alert-danger text-center">Loading...</div>
                }
                <div className="d-flex justify-content-center mt-4">
                    {
                        // isShowingAll === false ? <button className="showAllBtn" onClick={showAll}><FaArrowCircleDown /></button> : <button className="showLessBtn" onClick={showLess}><FaArrowCircleUp /></button>
                        isShowingAll === false ? <button className="pr-5 pl-5 border border-dark btn btn-light bg-light text-dark" onClick={showAll}><FaArrowCircleDown /></button> : <button className="border border-dark btn btn-dark text-light bg-dark pr-5 pl-5" onClick={showLess}><FaArrowCircleUp /></button>
                    }
                </div>
            </div>
        </div>
    )
}

export default Skills
